import { Outlet } from "react-router"
import Navbar from "../components/Navbar/Navbar"
import { Grid } from "@george-labs.com/design-system"
import Footer from "../components/Footer/Footer"
import { isFromGeorgeApp } from "../providers/AuthProvider"

const AppLayout = () => {
  return (
    <>
      {!isFromGeorgeApp() && <Navbar />}
      <Grid fluid={false}>
        <Outlet />
      </Grid>
      <Footer />
    </>
  )
}

export default AppLayout
